/**
 * Umplerea sablonului de email catre furnizor ("Waiting for Third Party").
 *
 * Sablonul e TEXT, nu HTML: ce iese de aici se arata ca text in
 * previzualizare (React il scapa) si pleaca ca text (serverul il scapa si
 * pune `<br />` la capat de rand). Nimic din sablon nu se executa.
 *
 * DOUA REGULI CA SA NU RAMANA GOLURI
 * ----------------------------------
 *
 *  - un RAND care are variabile si in care TOATE ies goale se scoate de tot:
 *    "Support contract: {$support.contract}" nu apare deloc pe un furnizor
 *    fara contract, in loc de "Support contract: " gol;
 *  - pe randurile cu variabile, spatiile duble se strang si parantezele
 *    ramase goale ("()", "[]") pleaca: "Charisma ({$app.name})" fara
 *    aplicatie iese "Charisma".
 *
 * O variabila NECUNOSCUTA (scrisa gresit) ramane cum e, ca sa se vada in
 * previzualizare - si randul ei nu se socoteste gol.
 */

const TOKEN = /\{\$[a-zA-Z_][a-zA-Z0-9_.]*\}/g

export function renderTemplate(text: string, values: Record<string, string>): string {
  const out: string[] = []
  for (const line of text.replace(/\r/g, '').split('\n')) {
    const tokens = line.match(TOKEN)
    if (!tokens) {
      out.push(line)
      continue
    }
    const known = tokens.every((t) => t in values)
    const empty = known && tokens.every((t) => (values[t] ?? '').trim() === '')
    if (empty) continue
    /* Strangerea se face pe sablon, nu pe valori: o descriere cu spatii duble
       sau cu "()" scrisa de client ramane cum a scris-o. Valorile intra in
       locul unor semne care nu sunt nici spatiu, nici paranteza. */
    const parts: string[] = []
    const marked = line.replace(TOKEN, (t) => {
      const value = t in values ? values[t] : t
      if (value.trim() === '') return ''
      parts.push(value)
      return `\u0000${parts.length - 1}\u0000`
    })
    out.push(tidy(marked).replace(/\u0000(\d+)\u0000/g, (_m, i: string) => parts[Number(i)]))
  }

  return out.join('\n').replace(/\n{3,}/g, '\n\n').trim()
}

/** Subiectul: un singur rand, umplut si strans. */
export function renderSubject(text: string, values: Record<string, string>): string {
  return tidy(renderTemplate(text.replace(/[\r\n]+/g, ' '), values).replace(/\s+/g, ' ')).trim()
}

function tidy(line: string): string {
  return line
    .replace(/\(\s*\)|\[\s*\]/g, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/[ \t]+([,.;:)\]])/g, '$1')
    .replace(/^([ \t]*)[,;][ \t]*/, '$1')
    .replace(/[ \t]+$/g, '')
}

/** Valori de proba, pentru previzualizarea din Settings. */
export const SAMPLE_VALUES: Record<string, string> = {
  '{$provider.name}': 'Hotel Soft SRL',
  '{$app.name}': 'Charisma ERP',
  '{$app.version}': '9.2',
  '{$app.vendor}': 'Charisma',
  '{$support.contract}': 'HS-2026/14',
  '{$customer.company}': 'Ana Grup',
  '{$ticket.title}': 'Charisma does not open',
  '{$ticket.description}': 'Since 9:00 no user can log in.\nThe service is running on the server.',
  '{$affected.servers}': 'BUCPS-SQL',
  '{$contact.name}': 'Ion Popa',
  '{$contact.email}': 'ion.popa@example.com',
  '{$contact.phone}': '+40 722 000 111',
  '{$sender.name}': 'Ana Ionescu',
}
